import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export default function useGetActiveScrapeBulksAnalytics(enabled = true) {
  const request: Request = {
    url: ENDPOINTS.scrape.scrapeBulk.activeAnalytics,
    config: {
      method: 'get',
    },
  };
  const requestConfig = {
    queryKey: [ENDPOINTS.scrape.scrapeBulk.activeAnalytics],
    queryFn: () => client(request),
    enabled,
    staleTime: 60 * 60 * 1000, // 60 minutes
  };

  const { data, ...rest } = useQuery<
    Response<{
      scrapeBulkProspect: {
        completed: number;
        total: number;
      };
      scrapeBulkCompany: {
        completed: number;
        total: number;
      };
    }>,
    CronoError
  >(requestConfig);

  return { data, ...rest };
}
